import { Component, h, Fragment } from "@stencil/core";
import { routerStore } from "@phn/state/router-store";
import { isDesktop } from "@phn/utility/helper";
import { navStateStore } from "@phn/state/nav-state-store";
import { isClosing, isOpened, isOpening } from "@phn/services/routing-manager";

@Component({
  tag: "phn-nd-drawer-selector",
  styleUrl: "drawer-selector.css",
})
export class DrawerSelector {
  render() {
    const { breakpoint } = routerStore.state;
    const { usingKeyboard, locale } = navStateStore.state;

    return isOpened() || isOpening() ? (
      <Fragment>
        <phn-nd-backdrop
          class={isClosing() || isOpening() ? "pointer-events-none" : ""}
        />
        {isDesktop(breakpoint) ? (
          <phn-nd-double-drawer
            class="drawer"
            locale={locale}
            receivedContent={true}
          />
        ) : (
          <phn-nd-single-drawer
            class="drawer"
            breakpoint={breakpoint}
            usingKeyboard={usingKeyboard}
            locale={locale}
            receivedContent={true}
          />
        )}
      </Fragment>
    ) : null;
  }
}
